import { createFileRoute } from "@tanstack/react-router";
import { SearchResultTemplate } from "~/features/search/SearchResultTemplate";

export const Route = createFileRoute("/_authenticated/search/result")({
  component: SearchResultTemplate,
});
